import { render, staticRenderFns } from "./pesquisaEstudanteFinancas.vue?vue&type=template&id=18b484ea&"
import script from "./pesquisaEstudanteFinancas.vue?vue&type=script&lang=js&"
export * from "./pesquisaEstudanteFinancas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports